import React from 'react'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'

export default function(ComposedComponent) {
  @withGraphQL(
    gql`
      query organization($organization: String) {
        organization(organizationSlug: $organization) {
          _id
          name
          slug
          logo {
            url
          }
          myRole
          createdAt
          bioServices {
            dactilar {
              active
            }
          }
        }
      }
    `,
    {
      options: {variables: {organization: getOrganization()}}
    }
  )
  class WithOrganization extends React.Component {
    static propTypes = {
      organization: PropTypes.object
    }
    render() {
      if (!this.props.organization._id) {
        return (
          <ComposedComponent
            {...this.props}
            organization={this.props.organization}
            organizationId={null}
          />
        )
      } else {
        return (
          <ComposedComponent
            {...this.props}
            organization={this.props.organization}
            organizationId={this.props.organization._id}
          />
        )
      }
    }
  }
  return WithOrganization
}

function getOrganization() {
  const organization = window.location.hostname.match(/^(?:www\.)?([^.]+)/)[1]
  if (organization === 'app' || organization === 'localhost') return null
  else {
    return organization
  }
}



// WEBPACK FOOTER //
// ./src/App/Decorators/withOrganization.js